var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"dot",class:[{ active: _vm.active }, _vm.size, _vm.color, _vm.customClass]})}
var staticRenderFns = []

export { render, staticRenderFns }